import {
	subscribeToRefreshToken as subscribeToRefreshTokenAction,
	unsubscribeToRefreshToken as unsubscribeToRefreshTokenAction,
	subscribeToInvalidToken as subscribeToInvalidTokenAction,
	unsubscribeToInvalidToken as unsubscribeToInvalidTokenAction,
	getUser as getUserAction,
	saveCredentials as saveCredentialsAction,
	postLogin as postLoginAction,
	loginWithToken as loginWithTokenAction,
	initCredentials as initCredentialsAction,
} from '@/store/modules/auth/actions';
import { useStore } from '@/utils/store';
import { UserId, ServerCredentials } from '@ply-io/ply-front-shared-utilities';

export const useAuthActions = () => {
	const { dispatch } = useStore();
	return {
		getUser: (payload: { id?: UserId }) => dispatch<{ id?: UserId }, unknown>(getUserAction, payload),
		subscribeToInvalidToken: () => dispatch<undefined, void>(subscribeToInvalidTokenAction, undefined),
		subscribeToRefreshToken: () => dispatch<undefined, void>(subscribeToRefreshTokenAction, undefined),
		unsubscribeToRefreshToken: () => dispatch<undefined, void>(unsubscribeToRefreshTokenAction, undefined),
		unsubscribeToInvalidToken: () => dispatch<undefined, void>(unsubscribeToInvalidTokenAction, undefined),
		saveCredentials: (payload: { creds: { token: string; account: unknown }; refreshToken?: boolean }) =>
			dispatch<{ creds: { token: string; account: unknown }; refreshToken?: boolean }, void>(saveCredentialsAction, payload),
		postLogin: (payload: {
			token: ServerCredentials['token'];
			refresh: ServerCredentials['refresh'];
			user_id: ServerCredentials['user'];
			active_account_id?: ServerCredentials['account'];
			avoidRedirect?: boolean;
			fromBroadcastChannel?: boolean;
		}) =>
			dispatch<
				{
					token: ServerCredentials['token'];
					refresh: ServerCredentials['refresh'];
					user_id: ServerCredentials['user'];
					active_account_id?: ServerCredentials['account'];
					avoidRedirect?: boolean;
					fromBroadcastChannel?: boolean;
				},
				void
			>(postLoginAction, payload),
		loginWithToken: (token: string) => dispatch<string, void>(loginWithTokenAction, token),
		initCredentials: (creds: ServerCredentials) => dispatch<{ creds: ServerCredentials }, void>(initCredentialsAction, { creds }),
	};
};
